import { getDeleteUserRoleQuery } from '@services/user/user.helpers';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteUserRole = () => {
  const client = useClient();
  const result = useMutation({
    mutationFn: (params: { userId: string; role: string; brokerageId?: string }) => {
      const { userId, role, brokerageId = '' } = params;
      const query = getDeleteUserRoleQuery({ brokerageId });
      return client.delete(`user/${userId}/role/${role}?${query}`);
    },
  });
  return { ...result, deleteUserRole: result.mutateAsync };
};
